function searchBtn() {
    jQuery(document).ready(function ($) {
        jQuery(document)
            .off('click.growtypeSearchOpen', '.btn-growtype-search-open')
            .on('click.growtypeSearchOpen', '.btn-growtype-search-open', function () {
                openSearch(jQuery(this))
            });

        jQuery(document)
            .off('click.growtypeSearchClose', '.btn-growtype-search-close')
            .on('click.growtypeSearchClose', '.btn-growtype-search-close', function (e) {
                e.preventDefault();
                closeSearch(jQuery(this))
            });
    });

    function openSearch(element) {
        let id = element.attr('data-search-id');
        let wrapper = $('#' + id);

        if (!wrapper.length) {
            wrapper = element.parent().find('.growtype-search-wrapper');
        }

        if (wrapper.is(':visible')) {
            element.addClass('is-active');
            wrapper.fadeOut();
        } else {
            element.removeClass('is-active');
            wrapper.fadeIn();
            wrapper.find('.growtype-search-input').focus();
        }
    }

    function closeSearch(element) {
        element.closest('.growtype-search-wrapper').fadeOut();
    }

}

export {searchBtn};
